/* eslint-disable react/prefer-es6-class, react/sort-comp, react/prop-types */
import React from 'react';

// Keep a list of rendered popovers, so we can close them when
// another one opens.
const popovers = [];

const Popover = React.createClass({
  displayName: 'Popover',

  propTypes: {
    align: React.PropTypes.oneOf([
      'left',
      'right',
      'top',
      'bottom',
    ]),
    className: React.PropTypes.string,
    content: React.PropTypes.object.isRequired,
    hidden: React.PropTypes.bool,
    onClose: React.PropTypes.func,
    onOpen: React.PropTypes.func,
  },

  statics: {
    closeAll() {
      popovers.forEach((popover) => popover.close());
    },
  },

  getDefaultProps() {
    return {
      align: 'top',
      className: '',
      hidden: true,
      onClose: null,
      onOpen: null,
    };
  },

  getInitialState() {
    return {
      hidden: this.props.hidden,
    };
  },

  /**
   * Add popover to the components array.
   */
  componentDidMount() {
    popovers.push(this);
  },

  /**
   * Remove the popover from the components array.
   */
  componentWillUnmount() {
    popovers.splice(popovers.indexOf(this), 1);
    document.removeEventListener('click', this.close);
  },

  /**
   * Closes this popover.
   */
  close() {
    this.setState({ hidden: true });
    document.removeEventListener('click', this.close);

    if (this.props.onClose) {
      this.props.onClose();
    }
  },

  /**
   * If the popover is currently revealed, hide it and bind
   * an event to close it when something is clicked.
   */
  handleClick() {
    if (this.state.hidden) {
      Popover.closeAll();
      document.addEventListener('click', this.close);
      this.setState({ hidden: false });

      if (this.props.onOpen) {
        this.props.onOpen();
      }
    }
  },

  render() {
    return (
      <div onClick={this.handleClick} className={this.props.className} style={{ position: 'relative' }}>
        {this.props.children}
        {this.renderPopover()}
      </div>
    );
  },

  renderPopover() {
    if (this.state.hidden) {
      return null;
    }

    return (
      <div className={`popover popover-${this.props.align}`}>
        {this.props.content}
      </div>
    );
  },
});

export default Popover;
